export enum DataLayerTypes {
  LULC = 'lulc',
  BIO_DIVERSITY = 'biodiversity',
  FOREST_LOSS = 'forest_loss',
  CANOPY_HEIGHT = 'canopy_height',
  DEM = 'dem',
  ECO_REGIONS = 'ecoregions',
  ESA_CCI_BIOMASS = 'esa_cci_biomass',
  PROTECTED_AREA_FOREST = 'protected_area_forest',
  // in types/enums.ts
  TIDAL_HEIGHT = 'tidal_height',
  FIRE_RISK = 'fire_risk',
  STORM_RISK = 'storm_risk',
}
